module.exports = __webpack_public_path__ + "img/mobile-ss.f47bff0f.png";